module.exports = __webpack_public_path__ + "static/img/shengXian.cd70f6aa.jpg";